import { DialogComponent } from "./chunk-FJH3KWUM.js";
import { Heading_default } from "./chunk-EXW7ZGG6.js";
import { Spinner_default } from "./chunk-KRDKEFRG.js";
import { noop } from "./chunk-KROBAS26.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/LoadingModal/LoadingModal.tsx
import React from "react";
import clsx from "clsx";
import { Dialog as HeadlessDialog } from "@headlessui/react";
var LoadingModal = _a => {
  var _b = _a,
    {
      isOpen,
      onClose,
      children,
      title,
      className
    } = _b,
    rest = __objRest(_b, ["isOpen", "onClose", "children", "title", "className"]);
  return /* @__PURE__ */React.createElement(DialogComponent, __spreadValues({
    isOpen,
    onClose: onClose || noop,
    className: clsx("pd-loading-modal", className)
  }, rest), /* @__PURE__ */React.createElement(DialogComponent.Backdrop, {
    className: "pd-loading-modal__backdrop"
  }), /* @__PURE__ */React.createElement(DialogComponent.Front, {
    className: "pd-loading-modal__front"
  }, /* @__PURE__ */React.createElement(DialogComponent.Panel, {
    className: "pd-loading-modal__panel"
  }, /* @__PURE__ */React.createElement(DialogComponent.Content, {
    className: "pd-loading-modal__content"
  }, /* @__PURE__ */React.createElement(Spinner_default, {
    size: "lg",
    className: "pd-mb-5"
  }), /* @__PURE__ */React.createElement(Heading_default, {
    as: HeadlessDialog.Title,
    size: "3",
    className: "pd-mb-1"
  }, title), children))));
};
var LoadingModal_default = LoadingModal;
export { LoadingModal_default };